import { render, staticRenderFns } from "./ads.vue?vue&type=template&id=6f06c563&scoped=true"
import script from "./ads.vue?vue&type=script&lang=js"
export * from "./ads.vue?vue&type=script&lang=js"
import style0 from "./ads.vue?vue&type=style&index=0&id=6f06c563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06c563",
  null
  
)

export default component.exports